export const vipSupportLinks = {
  telegram: 'https://t.me/creatorhero_support_bot?start=vip-group-request',
  whatsapp:
    'https://api.whatsapp.com/send/?phone=17862447680&text=Hi%2C%20I%27d%20like%20to%20have%20a%20VIP%20Support%20Group.&type=phone_number&app_absent=0',
}
